import { Link } from "react-router";
import { Building2 } from "lucide-react";
import MainLayout from "@/components/layouts";
import { Card, CardContent } from "@/components/ui/card";
import { useAppSelector } from "@/lib/store";
import { contactPropertyPath } from "@/lib/property-contact-scope";
import { ContactPropertyView } from "./property-view";

export default function ContactHome() {
  const properties = useAppSelector((state) => state.config.contactProperties);

  if (properties.length === 1) return <ContactPropertyView propertyId={properties[0].id} />;

  return (
    <MainLayout breadcrumb={[{ name: "Your properties", href: "#" }]} pageHeader={{ title: "Your properties", subtitle: "The properties you are a contact at" }}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {properties.map((property) => (
          <Link key={property.id} to={contactPropertyPath(property)}>
            <Card className="hover:bg-muted/50 transition-colors">
              <CardContent className="flex items-center gap-3">
                <Building2 className="h-5 w-5 text-muted-foreground" />
                <span className="font-medium">{property.name}</span>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </MainLayout>
  );
}
